module.exports = __webpack_public_path__ + "media/images/top/sample-be02f3a7bcf926b1382df044f1d5414e.jpg";